export { f32 as F32, f32 } from './F32.js';
export { f64 as F64, f64 } from './F64.js';
export { i8 as I8, i8 } from './I8.js';
export { i16 as I16, i16 } from './I16.js';
export { i32 as I32, i32 } from './I32.js';
export { i64 as I64, i64 } from './I64.js';
export { i128 as I128, i128 } from './I128.js';
export { i256 as I256, i256 } from './I256.js';
export { isize as ISize, isize } from './ISize.js';
export { u8 as U8, u8 } from './U8.js';
export { u16 as U16, u16 } from './U16.js';
export { u32 as U32, u32 } from './U32.js';
export { u64 as U64, u64 } from './U64.js';
export { u128 as U128, u128 } from './U128.js';
export { u256 as U256, u256 } from './U256.js';
export { usize as USize, usize } from './USize.js';
